import {ComponentProps, useState} from "react";
import {css, cx} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps extends ComponentProps<typeof Text> {
    linkText?: string;
    linkClassName?: string;
    hiddenInfo?: {
        linkTexts: [string, string];
        infoElement: React.ReactNode;
    };
}

export function LeadRodoTerms(props: IProps) {
    const {variant = "info_txt_3", color = "var(--colors-gray-800)", linkText = "zasady przetwarzania danych osobowych.", linkClassName, hiddenInfo} = props;

    const [showHiddenText, setShowHidddenText] = useState<boolean>(false);

    const rodoTermsUrl = rpAppLink.rodoTerms.base();

    return (
        <Text as="span" variant={variant} color={color} {...props}>
            Administratorem danych osobowych świadczonych w związku z realizacja umowy {hiddenInfo ? "są:" : "jest"} Property Group sp. z o.o.{" "}
            {hiddenInfo ? (
                <>
                    {showHiddenText && (
                        <>
                            {hiddenInfo.infoElement} <br />
                        </>
                    )}

                    <span onClick={() => setShowHidddenText(!showHiddenText)} className={cx(rodoLink, linkClassName)}>
                        {hiddenInfo.linkTexts[showHiddenText ? 1 : 0]}
                    </span>
                </>
            ) : (
                <Link href={rodoTermsUrl} target="_blank" textClassName={cx(rodoLink, linkClassName)}>
                    {linkText}
                </Link>
            )}
        </Text>
    );
}

const rodoLink = css({
    fontSize: "inherit",
    lineHeight: "inherit",
    textDecoration: "underline",
    cursor: "pointer"
});
import {ComponentProps, useState} from "react";
import {css, cx} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps extends ComponentProps<typeof Text> {
    linkText?: string;
    linkClassName?: string;
    hiddenInfo?: {
        linkTexts: [string, string];
        infoElement: React.ReactNode;
    };
}

export function LeadRodoTerms(props: IProps) {
    const {variant = "info_txt_3", color = "var(--colors-gray-800)", linkText = "zasady przetwarzania danych osobowych.", linkClassName, hiddenInfo} = props;

    const [showHiddenText, setShowHidddenText] = useState<boolean>(false);

    const rodoTermsUrl = rpAppLink.rodoTerms.base();

    return (
        <Text as="span" variant={variant} color={color} {...props}>
            Administratorem danych osobowych świadczonych w związku z realizacja umowy {hiddenInfo ? "są:" : "jest"} Property Group sp. z o.o.{" "}
            {hiddenInfo ? (
                <>
                    {showHiddenText && (
                        <>
                            {hiddenInfo.infoElement} <br />
                        </>
                    )}

                    <span onClick={() => setShowHidddenText(!showHiddenText)} className={cx(rodoLink, linkClassName)}>
                        {hiddenInfo.linkTexts[showHiddenText ? 1 : 0]}
                    </span>
                </>
            ) : (
                <Link href={rodoTermsUrl} target="_blank" textClassName={cx(rodoLink, linkClassName)}>
                    {linkText}
                </Link>
            )}
        </Text>
    );
}

const rodoLink = css({
    fontSize: "inherit",
    lineHeight: "inherit",
    textDecoration: "underline",
    cursor: "pointer"
});
